import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Button } from "@material-ui/core";
import { ModalMotivoBaja } from "./ModalMotivoBaja";
import { enviarPDFReceta, imprimirPDFReceta, repetirReceta } from "../../../../actions/recetasDigitales/RecetasDigitales";

export const AdministrarMenu = (props) => {
  const dispatch = useDispatch();

  const { recetaSeleccionada = {} } = useSelector(
    (state) => state.recetasDigitales
  );

  const [openModalMotivoBaja, setOpenModalMotivoBaja] = useState(false);
  const [motivoBaja, setMotivoBaja] = useState("");

  const onClickReimprimir = () => {
    dispatch(imprimirPDFReceta(recetaSeleccionada.idRecetaDigital));
  };

  const onClickEnviarMail = () => {
    dispatch(enviarPDFReceta(recetaSeleccionada.idRecetaDigital));
  };

  const onClickRetomar = () => {
    //setOpenModalGestionar(true);
    //dispatch(setReceta(item));
    props.postRetomarReceta(recetaSeleccionada);
  };

  const onClickRepetir = () => {
    dispatch(repetirReceta(recetaSeleccionada, props.postRetomarReceta));
  };

  const onClickAnular = () => {
    setOpenModalMotivoBaja(true);
  };

  return (
    <React.Fragment>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-evenly",
          flexWrap: "wrap",
        }}
      >
        {openModalMotivoBaja && (
          <ModalMotivoBaja
            open={openModalMotivoBaja}
            close={() => {
              setOpenModalMotivoBaja(false);
            }}
            idRecetaDigital={recetaSeleccionada.idRecetaDigital}
            titulo={"Motivo de Anulación"}
            motivoBaja={motivoBaja}
            setMotivoBaja={setMotivoBaja}
            setOpenModalGestionar={props.setOpenModalGestionar}
          />
        )}
        {recetaSeleccionada?.finalizada === true && (<Button
          style={{
            margin: "0.5rem",
            flexBasis: "30%",
            backgroundColor: "orange",
            color: "white",
          }}
          variant="contained"
          onClick={() =>
            onClickReimprimir()
          }
        >
          Imprimir
        </Button>)}
        {recetaSeleccionada?.finalizada === true && (<Button
          style={{
            margin: "0.5rem",
            flexBasis: "30%",
            backgroundColor: "green",
            color: "white",
          }}
          variant="contained"
          onClick={() =>
            onClickEnviarMail()
          }
        >
          Enviar por mail
        </Button>)}
        {recetaSeleccionada?.finalizada === true && (<Button
          style={{
            margin: "0.5rem",
            flexBasis: "30%",
            backgroundColor: "blue",
            color: "white",
          }}
          variant="contained"
          onClick={() =>
            onClickRepetir()
          }
        >
          Repetir
        </Button>)}
        {recetaSeleccionada?.finalizada === false && (<Button
          style={{
            margin: "0.5rem",
            flexBasis: "30%",
            backgroundColor: "purple",
            color: "white",
          }}
          variant="contained"
          onClick={() =>
            onClickRetomar()
          }
        >
          Retomar
        </Button>)}
        <Button
          style={{
            margin: "0.5rem",
            flexBasis: "30%",
            backgroundColor: "red",
            color: "white",
          }}
          variant="contained"
          onClick={() =>
            onClickAnular()
          }
        >
          Anular
        </Button>
      </div>
    </React.Fragment>
  );
};
